var PhxCheckout = (function (PhxCheckout) {
  //Import modules only for jest.
  if(typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
    const messenger = require('./messenger');
    Object.assign(PhxCheckout, messenger)
  }
  PhxCheckout.directDebitValidationHelper = function () {

    var isTouched = false;

    var _validateDirectDebit = function () {
      return _validateIBAN() === "OK";
    }

    /**
     Validate the provided IBAN number.
     https://en.wikipedia.org/wiki/International_Bank_Account_Number

     Output: Validation status
     **/

    var _mod97 = function (number) {
      var modValue = 97;
      while (number.length > 9) {
        number = (parseInt(number.substring(0, 9)) % modValue).toString() + number.substring(9);
      }
      return number % modValue;
    }

    var _hideErrorById = function (arrOfIds) {
      arrOfIds.forEach(function (element) {
        document.getElementById(element).style.display = 'none';
      })
    };

    var _validateIBAN = function () {
      var ddNumberErrorId = document.getElementById('dd_number_error');
      var validationSuccessEle = document.getElementById('ddIBANValidationSuccess');
      var ddElement = document.getElementById('id_iban');

      var ibanNumber = ddElement.value;

      var ddElementsToHideById = [
        'dd_iban_bad_length',
        'dd_iban_bad_chars',
        'dd_iban_checksum_fail',
        'dd_iban_empty'
      ];
      _hideErrorById(ddElementsToHideById);

      if (ibanNumber) {
        //remove spaces
        ibanNumber = ibanNumber.replace(/\s/g, "");
        //remove dashes
        ibanNumber = ibanNumber.replace(/-/g, "");

        var errorId = '';

        //Length varies per country. Doesn't exceed 34. Germany is 22
        if (ibanNumber.length < 5 && ibanNumber.length > 34) {
          errorId = 'iban_bad_length';
        }
        //check invalid characters
        else if (!/[A-Z]{2}[0-9A-Z]+/.test(ibanNumber)) {
          errorId = 'iban_bad_chars';
        }
        else {
          var rearranged = ibanNumber.substring(4) + ibanNumber.substring(0, 4);
          var converted = rearranged.replace(/[A-Z]/g, function (c) {
            return c.charCodeAt(0) - 55;
          });
          if (_mod97(converted) === 1) {
            ddNumberErrorId.style.display = 'none';
            ddElement.className = '';
            if (validationSuccessEle) {
              validationSuccessEle.className = 'success';
            }

            return "OK";
          }
          else {
            errorId = 'iban_checksum_fail';
          }
        }
      } else {
        errorId = 'iban_empty';
      }

      if (errorId) {
        ddNumberErrorId.style.display = 'inline';
        document.getElementById('dd_' + errorId).style.display = 'inline';
        ddElement.className = 'error';
        if (validationSuccessEle) {
          validationSuccessEle.className = '';
        }
      }

      return errorId;
    }

    var __obfuscateDirectDebit = function (cardData) {
      if (!cardData || !cardData.maskedIBAN || isTouched) {
        return;
      }

      var ddElement = document.getElementById("id_iban");

      ddElement.value = cardData.maskedIBAN;

      var isListenerRemoved = false;
      var _emptyDDValue = function () {
        ddElement.value = "";
        isTouched = true;
        PhxCheckout.messenger.postMessageToParent({
          action: "UNOBFUSCATEDVIEWEVENT"
        });
      };
      ddElement.addEventListener("focus", _emptyDDValue);

      ddElement.addEventListener("blur", function () {
        if (isListenerRemoved === false) {
          ddElement.removeEventListener("focus", _emptyDDValue);
          isListenerRemoved = true;
        }
      });

      PhxCheckout.messenger.postMessageToParent({
        action: "OBFUSCATEDVIEWEVENT"
      });
    };

    var _hideObfuscated = function () {
      var ddElement = document.getElementById("id_iban");
      ddElement.value = "";
      PhxCheckout.messenger.postMessageToParent({
        action: "UNOBFUSCATEDVIEWEVENT"
      });
    };
    return {
      validateDirectDebit: _validateDirectDebit,
      validateIBAN: _validateIBAN,
      obfuscateDirectDebit: __obfuscateDirectDebit,
      hideObfuscated: _hideObfuscated
    };
  }();

  return PhxCheckout;

}(PhxCheckout || {}));

if(typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
  module.exports = PhxCheckout //export it as module only for jest.
}
